<template>
  <div class="ma-0 text-xs-right">
    <v-btn class="white--text mr-0"
           color="primary"
           @click.stop="exportPdf()">
      {{ translation('pdf-export') }}
      <v-icon right dark>save_alt</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'pdfExport',
  props: {
    dashboardId: { type: String, required: true },
    dashboardName: { type: String, required: false }
  },
  mounted () {
    this.$log.info('Pdf export for dashboard:', this.dashboardId, '-', this.dashboardName)
  },
  computed: {
    ...mapGetters(['translation'])
  },
  methods: {
    exportPdf () {
      this.$log.info('exportingPdf...')

      // const firstChart = [this.firstChart]
      // const dataForExport = firstChart.concat(this.chartsImages)
      // Promise.all(dataForExport).then(res => {
      //   this.$log.info('Export data promise response: ', res)
      //
      //   let pdfMake = res[0]
      //
      //   // pdfmake is ready
      //   // Create document template
      //   let doc = {
      //     pageSize: 'A4',
      //     pageOrientation: 'portrait',
      //     pageMargins: [30, 30, 30, 30],
      //     content: []
      //   }
      //
      //   // add title
      //   doc.content.push({
      //     text: `${this.dashboardName()}`,
      //     fontSize: 14,
      //     bold: true,
      //     margin: [0, 20, 0, 15]
      //   })
      //
      //   // add graphs
      //   for (let i = 1; i < res.length; i++) {
      //     doc.content.push({
      //       image: res[i],
      //       width: 530
      //     })
      //   }
      //
      //   // download pdf file
      //   pdfMake.createPdf(doc).download(`${this.dashboardName}.pdf`)
      // })
    }
  }
}
</script>
